module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isCustomerSupport()) ? _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.config.name))]), _vm._v(" "), _c('span', {
    staticClass: "buttons"
  }, [(!_vm.tableFilterVisible && _vm.showTableFilter) ? _c('div', _vm._l((_vm.tableFilter), function(value, key) {
    return (value) ? _c('el-tag', {
      key: key,
      attrs: {
        "closable": "",
        "type": "info"
      },
      on: {
        "close": function($event) {
          return _vm.removeTableFilter(key)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.getFilterLabel(key)) + ":\n                    " + _vm._s(key === 'country_id' ?
      _vm.getFilterCountryName(value) :
      key === 'origin_id' ?
      _vm.getFilterOriginName(value) :
      value) + "\n                ")]) : _vm._e()
  }), 1) : _vm._e(), _vm._v(" "), (_vm.showRefreshButton) ? _c('el-button', {
    on: {
      "click": _vm.refresh
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  })]) : _vm._e(), _vm._v(" "), (
    _vm.config.shippedMultiselect &&
    _vm.multipleSelection.length > 0
  ) ? _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.setShippedStatus()
      }
    }
  }, [_vm._v("\n                Set Shipped Status\n            ")]) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "tableFilter",
    attrs: {
      "model": _vm.tableFilter
    }
  }, [(_vm.showTableFilter) ? _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "width": "250",
      "trigger": "manual"
    },
    model: {
      value: (_vm.tableFilterVisible),
      callback: function($$v) {
        _vm.tableFilterVisible = $$v
      },
      expression: "tableFilterVisible"
    }
  }, [(
    _vm.origins.length &&
    _vm.isCustomersRoute() &&
    _vm.isVisible
  ) ? _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Filter origin"
    },
    model: {
      value: (_vm.tableFilter.origin_id),
      callback: function($$v) {
        _vm.$set(_vm.tableFilter, "origin_id", $$v)
      },
      expression: "tableFilter.origin_id"
    }
  }, _vm._l((_vm.origins), function(origin) {
    return _c('el-option', {
      key: origin.name,
      attrs: {
        "label": origin.name,
        "value": origin.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.activeCountries.length &&
    !_vm.isUsUser() &&
    !_vm.isBrUser() &&
    !_vm.isUkUser() &&
    _vm.isOrdersRoute()
  ) ? _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Filter country"
    },
    model: {
      value: (_vm.tableFilter.country_id),
      callback: function($$v) {
        _vm.$set(_vm.tableFilter, "country_id", $$v)
      },
      expression: "tableFilter.country_id"
    }
  }, _vm._l((_vm.activeCountries), function(country) {
    return _c('el-option', {
      key: country.name,
      attrs: {
        "label": country.name,
        "value": country.country_id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showFilterStatus !== false) ? _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Filter status"
    },
    on: {
      "change": function($event) {
        return _vm.onStatusChange($event)
      }
    },
    model: {
      value: (_vm.tableFilter.status),
      callback: function($$v) {
        _vm.$set(_vm.tableFilter, "status", $$v)
      },
      expression: "tableFilter.status"
    }
  }, _vm._l((_vm.statusOptions), function(status) {
    return _c('el-option', {
      key: status,
      attrs: {
        "label": status,
        "value": status
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showFilterOrderDates !== false) ? _c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "Orders From",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.tableFilter.ordersFrom),
      callback: function($$v) {
        _vm.$set(_vm.tableFilter, "ordersFrom", $$v)
      },
      expression: "tableFilter.ordersFrom"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showFilterOrderDates !== false) ? _c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "Orders To",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.tableFilter.ordersTo),
      callback: function($$v) {
        _vm.$set(_vm.tableFilter, "ordersTo", $$v)
      },
      expression: "tableFilter.ordersTo"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('tableFilter')
      }
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.filterSearch
    }
  }, [_vm._v("Search")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "reference"
    },
    on: {
      "click": function($event) {
        _vm.tableFilterVisible = !_vm.tableFilterVisible
      }
    },
    slot: "reference"
  }, [_vm._v("Filter\n                        "), (_vm.cntFiltersOptions > 0) ? _c('span', [_vm._v("(" + _vm._s(_vm.cntFiltersOptions) + ")")]) : _vm._e()])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isSearchVisible()) ? _c('div', [_c('el-input', {
    attrs: {
      "placeholder": "Search",
      "suffix-icon": "el-icon-search"
    },
    model: {
      value: (_vm.term),
      callback: function($$v) {
        _vm.term = $$v
      },
      expression: "term"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.config.import) ? _c('div', {
    staticClass: "upload-btn"
  }, [_c('el-upload', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.uploading),
      expression: "uploading"
    }],
    ref: "upload",
    attrs: {
      "action": _vm.importEndpoint,
      "headers": _vm.rootConfig.headers,
      "before-upload": _vm.beforeUpload,
      "show-file-list": true,
      "multiple": true,
      "on-success": _vm.handleUploadSuccess,
      "on-error": _vm.handleUploadError
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Import")])], 1), _vm._v(" "), (_vm.showClearBtn) ? _c('el-button', {
    on: {
      "click": _vm.clearImport
    }
  }, [_vm._v("Clear")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.config.exportable) ? _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.exporting),
      expression: "exporting"
    }],
    on: {
      "click": _vm.doExport
    }
  }, [_vm._v("\n                Export\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.config.hideCreate) ? _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'admin',
          params: {
            model: _vm.config.route,
            id: 'all',
            action: 'new',
          },
        })
      }
    }
  }, [_vm._v("\n                New\n            ")]) : _vm._e(), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "width": "250",
      "trigger": "click"
    }
  }, [_c('div', [_c('el-checkbox-group', {
    staticClass: "el-checkbox-group",
    model: {
      value: (_vm.selectedVisibleColumns),
      callback: function($$v) {
        _vm.selectedVisibleColumns = $$v
      },
      expression: "selectedVisibleColumns"
    }
  }, _vm._l((_vm.config.columns), function(column) {
    return _c('div', {
      key: column.property
    }, [_c('el-checkbox', {
      key: column.property,
      attrs: {
        "label": column.property
      }
    }, [_vm._v(_vm._s(column.label))])], 1)
  }), 0), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetFormVisibleColumns()
      }
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveVisibleColumns()
      }
    }
  }, [_vm._v("Save")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_vm._v("Column Settings")])], 1)], 1)]), _vm._v(" "), (_vm.multipleSelection.length > 0) ? _c('div', {
    staticClass: "selection"
  }, [_c('div', {
    staticClass: "selection__button"
  }, [_c('el-button', {
    on: {
      "click": _vm.massDeletion
    }
  }, [_vm._v("Delete")])], 1), _vm._v(" "), _c('span', {
    staticClass: "selection__text"
  }, [_vm._v(_vm._s(_vm.multipleSelection.length) + " selected")])]) : _vm._e(), _vm._v(" "), (
    _vm.isCategoriesRoute() &&
    _vm.multipleSelection.length === 0 &&
    _vm.isVisible
  ) ? _c('div', {
    staticClass: "mb-8"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.onToggleSortCategories()
      }
    }
  }, [_vm._v("\n            Sort categories\n        ")]), _vm._v(" "), (_vm.showSortCategories) ? _c('div', {
    staticClass: "component-example border border-gray-500 rounded border-solid p-4 mt-4 bg-white"
  }, [_c('vue-nestable', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;

        return _c('vue-nestable-handle', {
          attrs: {
            "item": item
          }
        }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                ")])
      }
    }], null, false, 3614534639),
    model: {
      value: (_vm.nestedTableData),
      callback: function($$v) {
        _vm.nestedTableData = $$v
      },
      expression: "nestedTableData"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-4 flex"
  }, [_c('el-button', {
    staticClass: "el-button--primary mt-4",
    on: {
      "click": function($event) {
        return _vm.onSaveSortCategories()
      }
    }
  }, [_vm._v("\n                    Save\n                ")]), _vm._v(" "), _c('el-button', {
    staticClass: "mt-4",
    on: {
      "click": function($event) {
        return _vm.onCancelSortCategories()
      }
    }
  }, [_vm._v("\n                    Cancel\n                ")])], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "stripe": ""
    },
    on: {
      "sort-change": _vm.sortChange,
      "row-click": _vm.handleRowClick,
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _vm._l((_vm.getVisibleColumns), function(column) {
    return _c('el-table-column', {
      key: column.property,
      attrs: {
        "sortable": _vm.isSortable(column.property),
        "label": column.label,
        "prop": column.property,
        "width": column.width
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var row = ref.row;

          return [(column.property === 'total') ? _c(column.component, {
            tag: "span",
            attrs: {
              "value": _vm._f("currency")(row[column.property], row.currency + ' ')
            }
          }) : _c(column.component, {
            tag: "span",
            class: _vm.getColumnClasses(
              column.property,
              row[column.property]
            ),
            attrs: {
              "value": _vm.getTranslation(row[column.property])
            }
          })]
        }
      }], null, true)
    })
  })], 2), _vm._v(" "), (_vm.pageSize > 0) ? _c('div', {
    staticClass: "footer"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "total": _vm.numFound,
      "page-size": _vm.pageSize,
      "current-page": _vm.page
    },
    on: {
      "current-change": _vm.onPageChange
    }
  })], 1) : _vm._e()], 1) : _c('div', [_c('p', [_vm._v("Voucher Code:")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.customerSupportCoupon))])]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'admin',
          params: {
            model: _vm.config.route,
            id: 'all',
            action: 'new',
          },
        })
      }
    }
  }, [_vm._v("\n      Generate new\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b789f01"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VueCrudIndex.vue
// module id = 530
// module chunks = 1